/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import EmptyLayout from '@/views/layouts/EmptyLayout.vue';

export default [
    {
        path: 'md',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            // Kategorie produktów
            {
                path: 'program-categories',
                name: 'md-program-categories',
                meta: { auth: true },
                component: () => import('@/modules/md/program-categories/views/ProgramCategoriesList.vue')
            },
            {
                path: 'program-categories/add',
                name: 'md-program-categories-add',
                meta: { auth: true },
                component: () => import('@/modules/md/program-categories/views/ProgramCategoryForm.vue')
            },
            {
                path: 'program-categories/:id(\\d+)',
                name: 'md-program-categories-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/program-categories/views/ProgramCategoryForm.vue')
            },
            // Produkty
            {
                path: 'products',
                name: 'md-products',
                meta: { auth: true },
                component: () => import('@/modules/md/products/views/ProductsList.vue')
            },
            {
                path: 'products/add',
                name: 'md-products-add',
                meta: { auth: true },
                component: () => import('@/modules/md/products/views/ProductForm.vue')
            },
            {
                path: 'products/:id(\\d+)',
                name: 'md-products-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/products/views/ProductForm.vue')
            },
            // Promocje
            {
                path: 'promotions',
                name: 'md-promotions',
                meta: { auth: true },
                component: () => import('@/modules/md/promotions/views/PromotionsList.vue')
            },
            {
                path: 'promotions/add',
                name: 'md-promotions-add',
                meta: { auth: true },
                component: () => import('@/modules/md/promotions/views/PromotionForm.vue')
            },
            {
                path: 'promotions/:id(\\d+)',
                name: 'md-promotions-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/promotions/views/PromotionForm.vue')
            },
            // Promocja punkty za ekspozycję (zgłoszenia)
            {
                path: 'promotion-exposures',
                name: 'md-promotion-exposures',
                meta: { auth: true },
                component: () => import('@/modules/md/promotions/views/PromotionExposureRegistrationsList.vue')
            },
            {
                path: 'promotion-exposures/:id(\\d+)',
                name: 'md-promotion-exposures-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/promotions/views/PromotionExposureRegistrationForm.vue')
            },
            // Punkty użytkowników
            {
                path: 'user-points',
                name: 'md-user-points',
                meta: { auth: true },
                component: () => import('@/modules/md/user-points/views/UserPointsList.vue')
            },
            {
                path: 'user-points/add',
                name: 'md-user-points-add',
                meta: { auth: true },
                component: () => import('@/modules/md/user-points/views/UserPointForm.vue')
            },
            {
                path: 'user-points/:id(\\d+)',
                name: 'md-user-points-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/user-points/views/UserPointForm.vue')
            },
            // Raporty sprzedaży
            {
                path: 'sale-reports',
                name: 'md-sale-reports',
                meta: { auth: true },
                component: () => import('@/modules/md/sale-reports/views/SaleReportsList.vue')
            },
            {
                path: 'sale-reports/add',
                name: 'md-sale-reports-add',
                meta: { auth: true },
                component: () => import('@/modules/md/sale-reports/views/SaleReportCreateForm.vue')
            },
            {
                path: 'sale-reports/:id(\\d+)',
                name: 'md-sale-reports-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/sale-reports/views/SaleReportForm.vue')
            },
            // Raporty sprzedaży IMPORT HAJSIWO
            {
                path: 'sale-reports-hajsiwo',
                name: 'md-sale-reports-external',
                meta: { auth: true },
                component: () => import('@/modules/md/sale-reports-external/views/SaleReportsList.vue')
            },
            {
                path: 'sale-reports-hajsiwo/:id(\\d+)',
                name: 'md-sale-reports-external-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/sale-reports-external/views/SaleReportForm.vue')
            },
            // Dystrybotorzy
            {
                path: 'distributors',
                name: 'md-distributors',
                meta: { auth: true },
                component: () => import('@/modules/md/distributors/views/DistributorsList.vue')
            },
            {
                path: 'distributors/add',
                name: 'md-distributors-add',
                meta: { auth: true },
                component: () => import('@/modules/md/distributors/views/DistributorForm.vue')
            },
            {
                path: 'distributors/:id(\\d+)',
                name: 'md-distributors-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/distributors/views/DistributorForm.vue')
            },
            // Kategorie produktów
            {
                path: 'tax-offices',
                name: 'md-tax-offices',
                meta: { auth: true },
                component: () => import('@/modules/md/tax-offices/views/TaxOfficesList.vue')
            },
            {
                path: 'tax-offices/add',
                name: 'md-tax-offices-add',
                meta: { auth: true },
                component: () => import('@/modules/md/tax-offices/views/TaxOfficeForm.vue')
            },
            {
                path: 'tax-offices/:id(\\d+)',
                name: 'md-tax-offices-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/tax-offices/views/TaxOfficeForm.vue')
            },
            // Kody pocztowe
            {
                path: 'postal-codes',
                name: 'md-postal-codes',
                meta: { auth: true },
                component: () => import('@/modules/md/postal-codes/views/PostalCodesList.vue')
            },
            {
                path: 'postal-codes/add',
                name: 'md-postal-codes-add',
                meta: { auth: true },
                component: () => import('@/modules/md/postal-codes/views/PostalCodeForm.vue')
            },
            {
                path: 'postal-codes/:id(\\d+)',
                name: 'md-postal-codes-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/postal-codes/views/PostalCodeForm.vue')
            },
            // Produkty
            {
                path: 'companies',
                name: 'md-companies',
                meta: { auth: true },
                component: () => import('@/modules/md/companies/views/CompaniesList.vue')
            },
            {
                path: 'companies/add',
                name: 'md-companies-add',
                meta: { auth: true },
                component: () => import('@/modules/md/companies/views/CompanyForm.vue')
            },
            {
                path: 'companies/:id(\\d+)',
                name: 'md-companies-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/companies/views/CompanyForm.vue')
            },
            // Data imports
            {
                path: 'data-imports',
                name: 'md-data-imports',
                meta: { auth: true },
                component: () => import('@/modules/md/data-imports/views/DataImportsList.vue')
            },
            {
                path: 'data-imports/add',
                name: 'md-data-imports-add',
                meta: { auth: true },
                component: () => import('@/modules/md/data-imports/views/DataImportForm.vue')
            },
            // Kampanie SMS oraz Email
            {
                path: 'campaigns-sms',
                name: 'md-campaigns-sms',
                meta: { auth: true },

                component: () => import('@/modules/md/campaigns/views/SmsCampaignsList.vue')
            },
            {
                path: 'campaigns-sms/add',
                name: 'md-campaigns-sms-add',
                meta: { auth: true },
                component: () => import('@/modules/md/campaigns/views/SmsCampaignForm.vue')
            },
            {
                path: 'campaigns-sms/:id',
                name: 'md-campaigns-sms-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/campaigns/views/SmsCampaignForm.vue')
            },
            {
                path: 'campaigns-email',
                name: 'md-campaigns-email',
                meta: { auth: true },

                component: () => import('@/modules/md/campaigns/views/EmailCampaignsList.vue')
            },
            {
                path: 'campaigns-email/add',
                name: 'md-campaigns-email-add',
                meta: { auth: true },
                component: () => import('@/modules/md/campaigns/views/EmailCampaignForm.vue')
            },
            {
                path: 'campaigns-email/:id',
                name: 'md-campaigns-email-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/campaigns/views/EmailCampaignForm.vue')
            },
            {
                path: 'campaigns-push',
                name: 'md-campaigns-push',
                meta: { auth: true },

                component: () => import('@/modules/md/campaigns/views/PushCampaignsList.vue')
            },
            {
                path: 'campaigns-push/add',
                name: 'md-campaigns-push-add',
                meta: { auth: true },
                component: () => import('@/modules/md/campaigns/views/PushCampaignForm.vue')
            },
            {
                path: 'campaigns-push/:id',
                name: 'md-campaigns-push-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/campaigns/views/PushCampaignForm.vue')
            },
            {
                path: 'message-histories/:filterName(\\w+)?/:filterValue(\\d+)?',
                name: 'md-message-histories',
                meta: { auth: true },

                component: () => import('@/modules/md/campaigns/views/messagehistories/MessageHistoriesList.vue')
            },
            {
                path: 'data-imports/logs/:sourceId',
                name: 'md-data-imports-logs',
                meta: { auth: true },
                component: () => import('@/modules/md/data-imports/views/DataImportLog.vue')
            },
            // Promotional codes
            {
                path: 'promotional-code-sets',
                name: 'md-promotional-code-sets',
                meta: { auth: true },
                component: () => import('@/modules/md/promotional-codes/views/PromotionalCodeSetsList.vue')
            },
            {
                path: 'promotional-code-sets/add',
                name: 'md-promotional-code-sets-add',
                meta: { auth: true },
                component: () => import('@/modules/md/promotional-codes/views/PromotionalCodeSetForm.vue')
            },
            {
                path: 'promotional-code-sets/:id(\\d+)',
                name: 'md-promotional-code-sets-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/promotional-codes/views/PromotionalCodeSetForm.vue')
            },
            {
                path: 'used',
                name: 'md-promotional-code-sets-used',
                meta: { auth: true },
                component: () => import('@/modules/md/promotional-codes/views/PromotionalCodesUsedList.vue')
            },
            {
                path: 'used-edit/:id(\\d+)',
                name: 'md-promotional-code-sets-used-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/promotional-codes/views/PromotionalCodesUsedEdit.vue')
            },
            {
                path: 'generated',
                name: 'md-promotional-code-sets-generated',
                meta: { auth: true },
                component: () => import('@/modules/md/promotional-codes/views/PromotionalCodesGeneratedList.vue')
            },
            {
                path: 'promotional-code-failures',
                name: 'md-promotional-code-failures',
                meta: { auth: true },
                component: () => import('@/modules/md/promotional-codes/views/PromotionalCodeFailuresList.vue')
            },
            {
                path: 'generate',
                name: 'md-promotional-code-sets-generate',
                meta: { auth: true },
                component: () => import('@/modules/md/promotional-codes/views/PromotionalCodesGenerateForm.vue')
            },
            // Popupy
            {
                path: 'popups',
                name: 'md-popups',
                meta: { auth: true },
                component: () => import('@/modules/md/popups/views/PopupsList.vue')
            },
            {
                path: 'popups/add',
                name: 'md-popups-add',
                meta: { auth: true },
                component: () => import('@/modules/md/popups/views/PopupForm.vue')
            },
            {
                path: 'popups/:id(\\d+)',
                name: 'md-popups-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/popups/views/PopupForm.vue')
            },
            // Paleta kolorów - Front
            {
                path: 'colors-front',
                name: 'md-colors-front',
                meta: { auth: true },
                component: () => import('@/modules/md/settings/views/ColorsFront.vue')
            },
            // Paleta kolorów - Aplikacja mobilna
            {
                path: 'colors-mobile',
                name: 'md-colors-mobile',
                meta: { auth: true },
                component: () => import('@/modules/md/settings/views/ColorsMobile.vue')
            },
            // Paleta kolorów - Front
            {
                path: 'pages',
                name: 'md-pages',
                meta: { auth: true },
                component: () => import('@/modules/md/settings/views/Pages.vue')
            },
            // Quizzes
            {
                path: 'quizzes',
                name: 'md-quizzes',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizzesList.vue')
            },
            {
                path: 'quizzes/add',
                name: 'md-quizzes-add',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizForm.vue')
            },
            {
                path: 'quizzes/:id(\\d+)',
                name: 'md-quizzes-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizForm.vue')
            },
            {
                path: 'quizzes/:id(\\d+)/results',
                name: 'md-quizzes-results',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizResultsList.vue')
            },
            {
                path: 'quizzes/:id(\\d+)/results/:resultId(\\d+)',
                name: 'md-quizzes-result',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizResult.vue')
            },
            {
                path: 'quizzes/:id(\\d+)/questions',
                name: 'md-quizzes-questions',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizQuestionsList.vue')
            },
            {
                path: 'quizzes/:id(\\d+)/questions/add',
                name: 'md-quizzes-questions-add',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizQuestionForm.vue')
            },
            {
                path: 'quizzes/:id(\\d+)/questions/:itemId(\\d+)',
                name: 'md-quizzes-questions-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizQuestionForm.vue')
            },
            {
                path: 'quizzes/:id(\\d+)/theory/add',
                name: 'md-quizzes-theory-add',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizTheoryForm.vue')
            },
            {
                path: 'quizzes/:id(\\d+)/theory/:itemId(\\d+)',
                name: 'md-quizzes-theory-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/quizzes/views/QuizTheoryForm.vue')
            },
            // Szkolenia
            {
                path: 'courses/add',
                name: 'md-courses-add',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/CourseForm.vue')
            },
            {
                path: 'courses/configuration',
                name: 'md-courses-configuration',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/CourseConfiguration.vue')
            },
            {
                path: 'courses/:publicId',
                name: 'md-courses-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/CourseForm.vue')
            },
            {
                path: 'courses/:filterName(\\w+)?/:filterValue(\\d+)?',
                name: 'md-courses',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/CoursesList.vue')
            },
            {
                path: 'course/:courseId/subjects/add',
                name: 'md-course-subjects-add',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/subjects/CourseSubjectForm.vue')
            },
            {
                path: 'course/:courseId/subjects/:publicId',
                name: 'md-course-subjects-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/subjects/CourseSubjectForm.vue')
            },
            {
                path: 'course/:courseId/subjects',
                name: 'md-course-subjects',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/subjects/CourseSubjectsList.vue')
            },
            {
                path: 'course/:courseId/subjects/:subjectId/modules/add',
                name: 'md-course-modules-add',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/modules/CourseModuleForm.vue')
            },
            {
                path: 'course/:courseId/subjects/:subjectId/modules/:publicId',
                name: 'md-course-modules-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/modules/CourseModuleForm.vue')
            },
            {
                path: 'course/:courseId/subjects/:subjectId/modules',
                name: 'md-course-modules',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/modules/CourseModulesList.vue')
            },
            {
                path: 'course/:courseId/subjects/:subjectId/modules/:publicId/results',
                name: 'md-course-modules-results',
                meta: { auth: true },
                component: () => import('@/modules/md/courses/views/modules/CourseModulesResultsList.vue')
            },
            {
                path: 'scorm',
                name: 'md-scorm',
                meta: { auth: true },
                component: EmptyLayout,
                children: [
                    {
                        path: 'scormpackages',
                        name: 'md-scorm-scormpackages',
                        meta: { auth: true },
                        component: () => import('@/modules/md/scorm/scormPackages/views/ScormPackagesList.vue')
                    },
                    {
                        path: 'scormpackages/:id',
                        name: 'md-scorm-scormpackages-edit',
                        meta: { auth: true },
                        component: () => import('@/modules/md/scorm/scormPackages/views/ScormPackageForm.vue')
                    },
                    {
                        path: 'scormpackages/add',
                        name: 'md-scorm-scormpackages-add',
                        meta: { auth: true },
                        component: () => import('@/modules/md/scorm/scormPackages/views/ScormPackageForm.vue')
                    }
                ]
            },
            // wpisy formularza kontaktowego
            {
                path: 'contact-form-entries',
                name: 'contact-form-entries',
                meta: { auth: true },
                component: () => import('@/modules/md/contact-form-entries/views/ContactFormEntriesList.vue')
            },
            {
                path: 'contact-form-entries/:id(\\d+)',
                name: 'contact-form-entries-edit',
                meta: { auth: true },
                component: () => import('@/modules/md/contact-form-entries/views/ContactFormEntryDetails.vue')
            }
        ]
    }
];
